import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

export default function decorateurRectangleFacesLc(result, cmd, criterePlanning) {
  try {
    result.key = uuidv4();
    result.startString = moment(cmd.dateDebut).format('L');
    result.endString = moment(cmd.dateFin).format('L');
    result.label = cmd.annonceur;
    result.startStringHover = moment(cmd.dateDebut).format('L');
    result.endStringHover = moment(cmd.dateFin).format('L');
    result.labelHover = cmd.annonceur;
    result.tacite = '';
    if (cmd.reconductionTacite === 1 && cmd.renouvelee === 0) {
      result.tacite = '(RT)';
    }
    let rectEnd = moment(cmd.dateFin).clone();
    if (rectEnd > criterePlanning.dateEnd) {
      rectEnd = criterePlanning.dateEnd.clone();
    }
    const diffRectDateEnd = (rectEnd.diff(criterePlanning.dateEnd, 'days') + 1) / criterePlanning.days * 100;
    if (diffRectDateEnd < -94 || result.x1 > 94) {
      result.endString = null;
      result.startString = null;
      result.label = null;
    } else if (diffRectDateEnd < -85 || result.x1 > 85) {
      result.endString = null;
      result.label = null;
    } else if (diffRectDateEnd < -75 || result.x1 > 75) {
      result.label = null;
    }
  } catch (error) {
    throw error;
  }
}



// WEBPACK FOOTER //
// ./src/services/decorateur/decorateurRectangleFacesLc.js